<template>
  <div class="display">
    <div>
      <span class="axes2-title">
        <figure class="logo-holder">
          <img class="logo" :src="`${publicPath}img/Axes2-text-logo-sm.png`"/>
        </figure>
      </span>
      <div v-show="broadcast_control.length === 0" style="padding-top: 20px; margin: auto; text-align: center;" :key="component_key+1">
        <br/>
        <br/>
        <br/>
        <br/>
        <div v-if="please_wait">
          <p><span class="is-size-3">Please wait...</span></p>
        </div>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
      </div>
      <div v-show="broadcast_control.length != 0" style="height: 100%; padding-top: 5px;" :key="component_key">
        <div class="game_selector">
          <div class="select is-rounded is-medium">
            <select v-model="currentGameUniqueId" class="game_selector_select">
              <option v-for="(game, index) in availableGames" 
                v-bind:key="index" v-bind:value="game.id">
                <span v-if="game.title && game.location">
                  {{ game.title }} ({{ game.location }})
                </span>
                <span v-else-if="game.title">
                  {{ game.title }}
                </span>
                <span v-else-if="game.location">
                  {{ game.location }}
                </span>
                <span v-else>
                  (no title/location)
                </span>
              </option>
            </select>
          </div>
        </div>
        <br/>
        <div class="game_messages">
          <div v-for="(game, index) in broadcast_control" :key="index">
            <div v-if="currentGameUniqueId === game.uniqueId">

              <!-- Card 1: Game Info -->
              <div class="description_box">
                <p class="title_display"><i class="fas fa-bullseye"></i>
                  <span v-if="game.title">{{ game.title }}</span>
                  <span v-else>(no title)</span>
                </p>
                <hr style="margin: 0px; margin-bottom: 3px;"/>
                <p v-if="game.league" class="title_subtitle">{{ game.league }}</p>
                <p v-if="game.location" class="title_subtitle">{{ game.location }}</p>
              </div>

              <!-- Card 1.5: Game Completed -->
              <div v-if="game.status && game.status.control_type === 'game_completed'" style="margin-top: 5px;">
                <DisplayItem :msg="game.status"/>
              </div>

              <!-- Card 2: Rankings -->
              <div v-if="game.rankings" style="margin-top: 5px;">
                <DisplayItem :msg="game.rankings"/>
              </div>

              <!-- Card 3: Current Match -->
              <div v-if="game.current_match" style="margin-top: 5px;">
                <p class="card-label">Current Match</p>
                <DisplayItem :msg="game.current_match"/>
              </div>

              <!-- Next Up -->
              <div v-if="game.current_match && game.current_match.control_value.nextUp" class="next-up-box" style="margin-top: 5px;">
                <p class="next-up-label">Next Up</p>
                <p class="next-up-text">{{ game.current_match.control_value.nextUp }}</p>
              </div>

              <!-- Card 4: Previous Match -->
              <div v-if="game.previous_match" style="margin-top: 5px;">
                <p class="card-label">Previous Match</p>
                <DisplayItem :msg="game.previous_match"/>
              </div>

              <!-- Match History (expandable) -->
              <div v-if="game.match_history.length > 0" style="margin-top: 8px; text-align: center;">
                <a class="history-toggle" @click="$set(game, 'showHistory', !game.showHistory)">
                  {{ game.showHistory ? 'Hide' : 'Show' }} Match History ({{ game.match_history.length }})
                </a>
                <div v-if="game.showHistory">
                  <div v-for="(histItem, hIndex) in game.match_history" :key="hIndex">
                    <div v-if="histItem.title !== 'New Match'" style="margin-top: 5px;">
                      <DisplayItem :msg="histItem"/>
                    </div>
                  </div>
                </div>
              </div>

              <p class="last-updated" v-if="game.last_updated">Last updated: {{ game.last_updated.format('h:mm:ss a') }}</p>
            </div>
          </div>
        </div>
      </div>
      <br/>
      <br/>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import SocketioService from '../services/socketio.service.js';
import GameSummary from "../components/GameSummary.vue";
import axios from "axios";
import DisplayItem from "../components/DisplayItem.vue";


export default {
  name: 'display',
    components : {
      GameSummary,
      DisplayItem
    },
    computed: {
    },
    watch: {
      currentGameUniqueId(newGameId) {
        if (newGameId && newGameId !== 0) {
          this.getDisplayRecordsForGame(newGameId);
        }
      }
    },
    created() {
      console.log("SocketioService.setupSocketConnection()");
      SocketioService.setupSocketConnection();
    },
    beforeUnmount() {
      console.log("SocketioService.disconnect()");
      SocketioService.disconnect();
    },
    data () {
        return {
            debugMode: (process.env.VUE_APP_DEBUG_MODE === "true" ? true : false),
            publicPath: process.env.BASE_URL,
            broadcast_control: new Array(),
            availableGames: new Array(),
            component_key: 0,
            currentGameUniqueId: 0,
            game_selected: null,
            please_wait: false,
            first_request: true
        }
    },
    methods:{
      getAvailableGames() {
        var url = (this.debugMode ? "http://localhost:8080/displaygames" : "https://axes2api.azurewebsites.net/displaygames")
        this.please_wait = true;
        try {
          axios.get(url)
            .then((response) => {
              this.availableGames = response.data;
              
              // Auto-select the first (most recent) game
              if (this.availableGames.length > 0) {
                this.currentGameUniqueId = this.availableGames[0].id;
              }
              
              this.please_wait = false;
            }, (error) => {
              console.error("Error getting available games:", error);
              this.please_wait = false;
            });
        } catch(e) {
          console.log("getAvailableGames error", e);
        }
      },
      getDisplayRecordsForGame(gameId) {
        var url = (this.debugMode ? "http://localhost:8080/display/" : "https://axes2api.azurewebsites.net/display/")
        url += gameId;
        this.broadcast_control = [];
        this.please_wait = true;
        try {
          axios.get(url)
            .then((response) => {
              this.addItemsToBroadcastControl(response.data);
              this.please_wait = false;
            }, (error) => {
              console.error("Error getting display records for game:", error);
              this.please_wait = false;
            });
        } catch(e) {
          console.log("getDisplayRecordsForGame error", e);
        }
      },
      getControlRequests() {
        var items = SocketioService.items;
        SocketioService.items = [];
        
        // Filter items to only include those for the current game
        var filteredItems = items.filter(item => 
          item.control_value && item.control_value.uniqueId === this.currentGameUniqueId
        );
        
        this.addItemsToBroadcastControl(filteredItems);
      },
      addItemsToBroadcastControl(items) {
        for (var i = 0; i < items.length; i++) {
          var item = items[i];
          item.datetimestamp = new moment();

          var index = this.broadcast_control.map(object => object.uniqueId).indexOf(item.control_value.uniqueId);

          if (index === -1) {
            var game = {
              uniqueId: item.control_value.uniqueId,
              title: item.control_value.title,
              league: item.control_value.league,
              location: item.control_value.location,
              last_updated: new moment(),
              rankings: null,
              current_match: null,
              previous_match: null,
              status: null,
              match_history: [],
              showHistory: false
            };
            this.routeItemToGame(game, item);
            this.broadcast_control.push(game);
          } else {
            this.routeItemToGame(this.broadcast_control[index], item);
          }
        }
      },
      routeItemToGame(game, item) {
        game.last_updated = new moment();

        if (item.control_type === 'rankings') {
          game.rankings = item;
        } else if (item.control_type === 'match') {
          var itemId = item.control_value.uniqueItemId;
          if (game.current_match && game.current_match.control_value.uniqueItemId === itemId) {
            // same match as current — update in place (live scoring)
            game.current_match = item;
          } else if (game.previous_match && game.previous_match.control_value.uniqueItemId === itemId) {
            // same match as previous — update in place (e.g. completed status arriving after next match opened)
            game.previous_match = item;
          } else {
            // new match — shift previous to history, current to previous
            if (game.previous_match) {
              game.match_history.unshift(game.previous_match);
            }
            game.previous_match = game.current_match;
            game.current_match = item;
          }
        } else {
          // new_game, game_completed, skip_to_finals
          game.status = item;
        }
      },

      showScorecard: function(scorecard_id) {
        var url = (this.debugMode ? "http://localhost:8080/scorecard/" : "https://axes2api.azurewebsites.net/scorecard/")
        url += scorecard_id;
        var token = this.$parent.getApiToken();
        axios.get(url,{
            headers: {
                authorization: token
            }
        })
        .then((response) => {
          this.broadcast_control.forEach((item, index) => {
            if (item.control_type === 'scorecard' && item.control_value.scorecard_id === scorecard_id) {
              item.scorecard_data = response;
              this.component_key++;
            }
          });
        }, (error) => {
          alert(error);
        });
      },
      calculateThrowPoints: function (player) {
        return this.$parent.calculateThrowPoints(player);
      },
      calculateAxeHit: function (player, scorecard, basicScore) {
          return this.$parent.calculateAxeHit(player, scorecard, basicScore);
      },
      calculateThrowsFinals: function(player, scorecard) {  
          return this.$parent.calculateThrowsFinals(player, scorecard);
      }
    },
    mounted(){
        this.getAvailableGames();
        setInterval(() => {
          this.getControlRequests();
        }, 1000);
    }
}

</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;600&family=Orbitron:wght@500;700&display=swap');

.logo-holder {
    padding-top: 8px;
    width: intrinsic;
}
.logo {
    width: 55%;
    float: right;
}
.logo_please_wait {

}
.axes2-title {
  top: 0px;
  right: 0px;
  position: absolute;
  z-Index: 1000;
}

@media print {
  .game_selector {
    display: none;
  }
}

.game_selector, .game_messages {
  max-width: 375px;
  margin: auto;
}
.game_selector_select {
  background-color: rgba(20, 60, 20, 0.85);
  color: #f8e769;
  padding: 12px 10px;
  border: 1px solid rgba(240, 220, 120, 0.6);
  border-radius: 10px;
  width: 100%;
  max-width: 420px;
  box-shadow: 0 0 10px rgba(0,0,0,0.25);
  font-family: 'Inter', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

.display {
  background: linear-gradient(135deg, #163a16 0%, #2a5a2a 60%, #1b3b1b 100%);
  color: #f5e76e;
  height: 100%;
  width: 100%;
  margin: auto;
  font-family: 'Inter', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

.loading-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.55);
  color: #f5f5f5;
  font-size: 1.1rem;
  pointer-events: none;
}

.title_display {
  font-family: 'Orbitron', sans-serif;
  font-size: 1.3rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}

.weather_display, .title_subtitle, .location_display {
  font-size: 0.85rem;
  color: #f6d069;
}

.description_box {
    position: relative;
    padding: 12px;
    margin-left: 5px;
    margin-right: 5px;
    background-color: rgba(5, 55, 10, 0.85);
    color: #f5e76e;
    border-radius: 10px;
    border: 2px solid transparent;
    background-clip: padding-box;
}

.description_box::before {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: inherit;
    padding: 2px;
    background: linear-gradient(135deg, rgba(240,220,120,0.9), rgba(30,120,40,0.9));
    -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    -webkit-mask-composite: destination-out;
    mask-composite: exclude;
    pointer-events: none;
}

.next-up-box {
  position: relative;
  padding: 8px 12px;
  margin-left: 5px;
  margin-right: 5px;
  background-color: rgba(5, 55, 10, 0.85);
  border-radius: 8px;
  border: 2px solid transparent;
  background-clip: padding-box;
  text-align: center;
}

.next-up-box::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: inherit;
  padding: 2px;
  background: linear-gradient(135deg, rgba(240,220,120,0.9), rgba(30,120,40,0.9));
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  -webkit-mask-composite: destination-out;
  mask-composite: exclude;
  pointer-events: none;
}

.next-up-label {
  font-family: 'Orbitron', sans-serif;
  font-size: 0.7rem;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: rgba(240, 220, 120, 0.6);
}

.next-up-text {
  font-size: 1.1rem;
  color: #f5e76e;
  font-weight: 600;
}

.card-label {
  font-family: 'Orbitron', sans-serif;
  font-size: 0.7rem;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: rgba(240, 220, 120, 0.6);
  margin-left: 8px;
  margin-bottom: 2px;
}

.history-toggle {
  font-size: 0.85rem;
  color: #f6d069;
  cursor: pointer;
  text-decoration: underline;
}

.last-updated {
  font-size: 0.7rem;
  color: rgba(240, 220, 120, 0.45);
  text-align: center;
  margin-top: 10px;
}

.bullseye {
  border: 2px solid #ffd700;
  box-shadow: 0 0 14px rgba(255, 215, 0, 0.65);
}
</style>